module.exports = "/build/web/svg/event/evenement.891516fe281fafbf82614698153a29d0.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/event/evenement.svg
// module id = 157
// module chunks = 24